// extracted by mini-css-extract-plugin
module.exports = {"panel":"ConceptPanel-module__panel__2aet1","deselect":"ConceptPanel-module__deselect__17b3e"};